import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'as-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss', '../data-circles/data-circles.component.scss']
})
export class DataCardComponent implements OnInit {

  @Input() header: string;

  constructor() { }

  ngOnInit() {
  }

}
